<template lang="pug">
page-text
	p(slot="sub")
		a(href="https://resources.inlearno.ru/documents/privacy-policy.pdf") Политика конфиденциальности

	h1 Политика конфиденциальности

	h2 I. Общие положения

	p
		| Настоящие Положение о политике конфиденциальности (далее — Положение) является
		| официальным документом ООО «Образовательные технологии», расположенного
		| по адресу: 129085, г. Москва, Звездный бульвар, д. 19, стр. 1 (далее — «Компания»/
		| «Оператор»), и определяет порядок обработки и защиты информации о физических лицах
		| (далее — Пользователи), пользующихся сервисами, информацией, услугами,
		| программами (в т.ч. программами лояльности) и продуктами интернет-магазина,
		| расположенного на доменном имени www.inlearno.ru (далее — Сайт).
		| Соблюдение конфиденциальности важно для Компании, ведь целью данной Политики
		| конфиденциальности является обеспечение защиты прав и свобод человека и гражданина
		| при обработке его персональных данных, в том числе защиты прав
		| на неприкосновенность частной жизни, личную и семейную тайну,
		| от несанкционированного доступа и разглашения.

	p
		| Мы разработали Политику Конфиденциальности, которая описывает, как
		| мы осуществляем обработку персональных данных — любые действия (операции) или
		| совокупность действий (операций), совершаемых с использованием средств
		| автоматизации или без использования таких средств с персональными данными, включая
		| сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
		| извлечение, использование, передачу (распространение, предоставление, доступ),
		| обезличивание, блокирование, удаление, уничтожение персональных данных.

	p
		| Отношения, связанные с обработкой персональных данных и информации
		| о пользователях Сайта, регулируются настоящим Положением, иными официальными
		| документами Оператора и действующим законодательством РФ

	p
		| Обработка персональных данных осуществляется нами на законной и справедливой
		| основе, действуя разумно и добросовестно и на основе принципов:

	p
		| — законности целей и способов обработки персональных данных;
		| — добросовестности;
		| — соответствия целей обработки персональных данных целям, заранее определенным
		| и заявленным при сборе персональных данных, а также полномочиям Компании;
		| — соответствия объема и характера обрабатываемых персональных данных, способов
		| обработки персональных данных целям обработки персональных данных

	p
		| Настоящая Политика Конфиденциальности регулирует любой вид обработки
		| персональных данных и информации личного характера (любой информации,
		| позволяющей установить личность, и любой иной информации, связанной с этим)
		| о физических лицах, которые являются потребителями продукции или услуг Компании.

	p
		| Настоящая Политика распространяется на обработку личных, персональных данных,
		| собранных любыми средствами, как активными, так и пассивными, как через Интернет,
		| так и без его использования, от лиц, находящихся в любой точке мира.

	h2 II. Сбор персональных данных

	p
		| Целью обработки персональных данных является выполнения обязательств Оператора
		| перед Пользователями в отношении использования Сайта и его сервисов.

	p
		| Обработка персональных данных пользователей осуществляется с согласия субъекта
		| персональных данных на обработку его персональных данных.

	p
		| Под персональными данными понимается любая информация, относящаяся к прямо или
		| косвенно определенному, или определяемому физическому лицу (субъекту персональных
		| данных) и которая может быть использована для идентификации определенного лица
		| либо связи с ним.

	p
		| Мы можем запросить у Вас персональные данные в любой момент, когда Вы связываетесь
		| с Компанией. Компания может использовать такие данные в соответствии с настоящей
		| Политикой Конфиденциальности. Она также может совмещать такую информацию с иной
		| информацией для целей предоставления и улучшения своих продуктов, услуг,
		| информационного наполнения (контента) и коммуникаций.

	p
		| Ниже приведены некоторые примеры типов персональных данных, которые Компания
		| может собирать, и как мы можем использовать такую информацию.

	p
		| Мы можем собирать различные данные/информацию, включая:

	ul
		li имя и фамилию,
		li дату рождения;
		li пол, семейное положение;
		li почтовый адрес;
		li номер телефона;
		li адрес электронной почты;
		li информацию о банковских картах (ФИО, № карты).

	p
		| Персональные данные могут также включать в себя дополнительно предоставляемые
		| Пользователями по запросу Оператора в целях исполнения Оператором обязательств
		| перед Пользователями, вытекающих из договора на оказание услуг. Оператор вправе,
		| в частности, запросить у Пользователя копию документа, удостоверяющего личность,
		| либо иного документа, содержащего имя, фамилию, фотографию Пользователя, а также
		| иные дополнительные данные, которые, по усмотрению Оператора, будут являться
		| необходимыми и достаточными для идентификации такого Пользователя и позволят
		| исключить злоупотребления и нарушения прав третьих лиц.

	p
		| Когда Вы привлекаете к нашим мероприятиям и активностям других лиц или приглашаете
		| их к коммуникациям с нами, Компания может собирать предоставляемые Вами
		| персональные данных об этих лицах, такую как: имя, фамилия, дата рождения, почтовый
		| адрес, адрес электронной почты и номер телефона.

	p
		| При обработке персональных данных нами обеспечивается точность персональных
		| данных, их достаточность, а в необходимых случаях и актуальность по отношению
		| к целям обработки персональных данных.

	h2 III. Хранение и использование персональных данных

	p
		| Персональные данные Пользователей хранятся исключительно на электронных носителях
		| и обрабатываются с использованием автоматизированных систем, за исключением
		| случаев, когда неавтоматизированная обработка персональных данных необходима
		| в связи с исполнением требований законодательства.

	h3 КАК МЫ ИСПОЛЬЗУЕМ ВАШУ ПЕРСОНАЛЬНУЮ ИНФОРМАЦИЮ

	p
		| Собираемые нами персональные данные позволяют направлять Вам уведомления о новых
		| продуктах и услугах, специальных предложениях и различных событиях. Они также
		| помогает нам улучшать наши услуги, контент и коммуникации. Если Вы не желаете быть
		| включенным в наш список рассылки, Вы можете в любое время отказаться от рассылки
		| путём информирования нас по указанным контактам для обратной связи, а также внесения
		| изменений в настройках вашего профиля на сайте.
	p
		| Время от времени мы можем использовать Ваши персональные данные для отправки
		| важных уведомлений, содержащих информацию об изменениях наших положений,
		| условий и политик, а также подтверждающих размещенные Вами заказы и совершенные
		| покупки. Поскольку такая информация важна для Ваших взаимоотношений с Компанией,
		| Вы не можете отказаться от получения таких сообщений.
	p
		| Мы также можем использовать персональную информацию для внутренних целей, таких
		| как: проведение аудита, анализ данных и различных исследований в целях улучшения
		| продуктов и услуг Компании, а также взаимодействие с потребителями.
	p
		| Если Вы принимаете участие в розыгрыше призов, конкурсе или похожем
		| стимулирующем мероприятии, мы сохраняем за собой право использовать
		| предоставляемые Вами персональные данные для управления такими программами.

	h3 	СБОР И ИСПОЛЬЗОВАНИЕ ИНФОРМАЦИИ, НЕ ЯВЛЯЮЩЕЙСЯ ПЕРСОНАЛЬНОЙ

	p
		| Мы также собираем персональные данные, не являющиеся персональными − данные,
		| не позволяющие прямо ассоциировать их с каким-либо определённым лицом. Мы можем
		| собирать, использовать, передавать и раскрывать информацию, не являющуюся
		| персональной, для любых целей. Ниже приведены примеры информации, не являющейся
		| персональной, которую мы собираем, и как мы можем её использовать:
	p
		| Мы можем собирать персональные данные, такие как: сведения о роде занятий, языке,
		| почтовом индексе, уникальном идентификаторе устройства, местоположении и временной
		| зоне, в которой используется тот или иной продукт, для того чтобы лучше понимать
		| поведение потребителей и улучшать наши продукты, услуги и коммуникации.
	p
		| Мы можем также собирать персональные данные/информацию о том, чем интересуется
		| пользователь на нашем веб-сайте при использовании других наших продуктов и сервисов.
		| Такие персональные данные/информация собирается и используется для того, чтобы
		| помочь нам предоставлять более полезную информацию нашим покупателям и для
		| понимания того, какие элементы нашего сайта, продуктов и услуг наиболее интересны.
		| Для целей настоящей Политики Конфиденциальности совокупные данные
		| рассматриваются как данные/информация, не являющиеся персональными.
	p
		| Если мы совмещаем информацию, не являющуюся персональной, с персональной
		| информацией, такая совокупная информация будет рассматриваться как персональная
		| информация, пока такая информация будет являться совмещённой.

	h2 IV. Передача персональных данных

	p
		| Персональные данные Пользователей не передаются каким-либо третьим лицам,
		| за исключением случаев, прямо предусмотренных настоящими Правилами.
	p
		| Обработка персональных данных Пользователя осуществляется без ограничения срока,
		| любым законным способом, в том числе в информационных системах персональных
		| данных с использованием средств автоматизации или без использования таких средств.
	p
		| Пользователь соглашается с тем, что Оператор вправе передавать персональные данные
		| третьим лицам, в частности, организаторам мероприятий, курьерским службам,
		| организациями почтовой связи, операторам электросвязи и т.д., исключительно для целей,
		| указанных в разделе «Сбор персональных данных» настоящей Политики
		| конфиденциальности
	p
		| При указании пользователя или при наличии согласия пользователя возможна передача
		| персональных данных Пользователя третьим лицам-контрагентам Оператора с условием
		| принятия такими контрагентами обязательств по обеспечению конфиденциальности
		| полученной информации, в частности, при использовании приложений.
	p
		| Приложения, используемые Пользователями на Сайте, размещаются и поддерживаются
		| третьими лицами (разработчиками), которые действуют независимо от Оператора
		| и не выступают от имени или по поручению Оператора. Пользователи обязаны
		| самостоятельно ознакомиться с правилами оказания услуг и политикой защиты
		| персональных данных таких третьих лиц (разработчиков) до начала использования
		| соответствующих приложений.
	p
		| Персональные данные Пользователя могут быть переданы по запросам уполномоченных
		| органов государственной власти РФ только по основаниям и в порядке, установленным
		| законодательством РФ.
	p
		| Оператор осуществляет блокирование персональных данных, относящихся
		| к соответствующему Пользователю, с момента обращения или запроса Пользователя или
		| его законного представителя либо уполномоченного органа по защите прав субъектов
		| персональных данных на период проверки, в случае выявления недостоверных
		| персональных данных или неправомерных действий.

	h3 РАСКРЫТИЕ ИНФОРМАЦИИ ТРЕТЬИМ ЛИЦАМ

	p
		| В некоторых случаях Компания может предоставлять определенную персональную
		| информацию и данные стратегическим партнерам, которые работают с Компанией для
		| предоставления продуктов и услуг, или тем из них, которые помогают Компании
		| реализовывать продукты и услуги потребителям. Мы предоставляем третьим лицам
		| минимальный объем персональных данных, необходимый только для оказания требуемой
		| услуги или проведения необходимой транзакции.
	p
		| Персональная информация будет предоставляться Компанией только в целях обеспечения
		| потребителей продуктами и услугами, а также для улучшения этих продуктов и услуг,
		| связанных с ними коммуникаций. Такая информация не будет предоставляться третьим
		| лицам для их маркетинговых целей.
	p
		| Для использования Ваших персональных данных для любой иной цели мы запросим Ваше
		| Согласие на обработку Ваших персональных данных.

	h3 ПОСТАВЩИКИ УСЛУГ

	p
		| Компания предоставляет персональные данные/информацию Компаниям, оказывающим
		| такие услуги, как: обработка информации, предоставление кредитов, исполнение заказов
		| потребителей, доставка, иные виды обслуживания потребителей, определение вашего
		| интереса к нашим продуктам и услугам, проведение опросов, направленных на изучение
		| наших потребителей или удовлетворения качеством сервиса. Такие компании обязуются
		| защищать Вашу информацию независимо от страны своего расположения.

	h3 ИНЫЕ ЛИЦА

	p
		| Компании может быть необходимо — в соответствии с законом, судебным порядком,
		| в судебном разбирательстве и/или на основании публичных запросов или запросов
		| от государственных органов на территории или вне территории страны Вашего
		| пребывания — раскрыть Ваши персональные данные. Мы также можем раскрывать
		| персональные данные/информацию о Вас, если мы определим, что такое раскрытие
		| необходимо или уместно в целях национальной безопасности, поддержания правопорядка
		| или иных общественно важных случаях.
	p
		| Мы также можем раскрывать персональные данные/информацию о Вас, если
		| мы определим, что раскрытие необходимо для приведения в исполнение наших
		| положений и условий либо для целей защиты нашей деятельности и наших пользователей.
		| Дополнительно в случае реорганизации, слияния или продажи мы можем передать любую
		| или всю собираемую нами персональную информацию соответствующему третьему лицу.

	h2 V. Уничтожение персональных данных

	p
		| Персональные данные пользователя уничтожаются при:

	ul
		li
			| удалении Оператором информации, размещаемой Пользователем, а также
			| персональной страницы Пользователя в случаях, установленных договором купли
			| продажи (оферта);
		li
			| при отзыве субъектом персональных данных согласия на обработку персональных
			| данных.

	h3 ИДЕНТИФИКАЦИОННЫЕ ФАЙЛЫ (СOOKIES) И ИНЫЕ ТЕХНОЛОГИИ

	p
		| Веб-сайт, интерактивные услуги и приложения, сообщения электронной почты и любые
		| иные коммуникации от лица Компании могут использовать идентификационные файлы
		| cookies и иные технологии, такие как: пиксельные ярлыки (pixel tags), веб-маяки (web
		| beacons). Такие технологии помогают нам лучше понимать поведение пользователей,
		| сообщают нам, какие разделы нашего сайта были посещены пользователями, и измеряют
		| эффективность рекламы и сетевых поисков. Мы рассматриваем информацию, собираемую
		| файлами cookies и иными технологиями как информацию, не являющуюся персональной.
		| Нашей целью в таких случаях является обеспечение более удобного и персонального
		| взаимодействия с Компанией. Например, зная Ваше имя, мы можем использовать его
		| в наших коммуникациях. Зная, что кто-либо, используя Ваш компьютер или устройство,
		| приобрел определённый продукт или воспользовался определенной услугой, мы можем
		| обеспечивать более полное соответствие Вашим интересам рекламных сообщений
		| и сообщений электронной почты. В конечном итоге все эти знания помогают нам
		| предоставлять Вам обслуживание высшего качества.
	p
		| Если вы можете отключить cookies в настройках используемого Вами веб-браузера или
		| мобильного устройства. Следует учесть, что некоторые функции веб-сайта могут стать
		| недоступными после отключения cookies.
	p
		| Как и в случае большинства веб-сайтов, мы собираем некоторую информацию
		| автоматически и храним её в файлах статистики. Такая информация включает в себя адрес
		| Интернет-протокола (IP-адрес), тип и язык браузера, информацию о поставщике
		| Интернет-услуг, страницы отсылки и выхода, сведения об операционной системе, отметку
		| даты и времени, а также сведения о посещениях. Мы используем такую информацию для
		| понимания и анализа тенденций, администрирования сайта, изучения поведения
		| пользователей на сайте и сбора демографической информации о нашем основном
		| контингенте пользователей в целом. Компания может использовать такую информацию
		| в своих маркетинговых целях.
	p
		| В некоторых наших сообщениях электронной почты мы используем интерактивные
		| ссылки на информацию, размещённую на сайте Компании. Когда пользователи проходят
		| по таким ссылкам, прежде чем они попадают на страницу назначения на нашем веб-сайте,
		| их запросы проходят отдельную регистрацию. Мы отслеживаем такие «проходные»
		| данные, для того чтобы помочь нам определить интерес к отдельным темам и измерить
		| эффективность наших коммуникаций с потребителями. Если Вы предпочитаете, чтобы
		| Ваши обращения не отслеживались подобным образом, Вы не должны проходить
		| по текстовым или графическим ссылкам в сообщениях электронной почты.
	p
		| Пиксельные ярлыки позволяют нам направлять сообщения электронной почты в формате,
		| читаемом потребителями, и сообщают нам, были ли такие сообщения прочитаны.
		| Мы можем использовать такую информацию для ограничения количества направляемых
		| потребителям сообщений или прекращения их направления.

	h2 VI. Защита персональных данных

	p
		| Компания предпринимает меры предосторожности — включая правовые,
		| организационные, административные, технические и физические — для обеспечения
		| защиты Ваших персональных данных в соответствии со ст. 19 Федерального закона
		| от 27.07.2006 N 152-ФЗ «О персональных данных» в целях обеспечения защиты
		| персональных данных Пользователя от неправомерного или случайного доступа к ним,
		| уничтожения, изменения, блокирования, копирования, распространения, а также от иных
		| неправомерных действий третьих лиц.
	p
		| Когда Вы используете некоторые продукты, услуги или приложения Компании или
		| размещаете записи на форумах, в чатах или социальных сетях, предоставляемые Вами
		| персональные данные видны другим пользователям и могут быть прочитаны, собраны или
		| использованы ими. Вы несёте ответственность за персональные данные, которые Вы
		| предпочитаете предоставлять, в таких случаях самостоятельно. Например, если Вы
		| указываете своё имя и адрес электронной почты в записи на форуме, такая информация
		| является публичной. Пожалуйста, соблюдайте меры предосторожности при
		| использовании таких функций.

	h3 ЦЕЛОСТНОСТЬ И СОХРАНЕНИЕ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ
	p
		| Взаимодействуя с Компанией, Вы можете легко поддерживать свои персональные данные
		| и информацию в актуальном состоянии. Мы будем хранить Ваши персональные данные
		| и информацию в течение срока, необходимого для выполнения целей, описываемых
		| в настоящей Политике Конфиденциальности, за исключением случаев, когда более
		| длительный период хранения данных и информации необходим в соответствии
		| с законодательством либо разрешён им.

	h3 СТОРОННИЕ САЙТЫ И УСЛУГИ
	p
		| Веб-сайты, продукты, приложения и услуги Компании могут содержать ссылки на веб-
		| сайты, продукты и услуги третьих лиц. Наши продукты и услуги могут также
		| использовать или предлагать продукты или услуги третьих лиц. Персональные данные
		| и информация, собираемая третьими лицами, которые могут включать такие сведения, как
		| данные местоположения или контактная информация, регулируется правилами
		| соблюдения конфиденциальности таких третьих лиц. Мы призываем Вас изучать правила
		| соблюдения конфиденциальности таких третьих лиц.
	p
		| Оператор не несет ответственности за действия третьих лиц, получивших в результате
		| использования Интернета или Услуг Сайта доступ к информации о Пользователе
		| и за последствия использования данных и информации, которые, в силу природы Сайта,
		| доступны любому пользователю сети Интернет.

	h3 СОБЛЮДЕНИЕ ВАШЕЙ КОНФИДЕНЦИАЛЬНОСТИ НА УРОВНЕ КОМПАНИИ
	p
		| Для того чтобы убедиться, что Ваши персональные данные находятся в безопасности,
		| мы доводим нормы соблюдения конфиденциальности и безопасности до работников
		| Компании и строго следим за исполнением мер соблюдения конфиденциальности внутри
		| Компании.

	h3 ВОПРОСЫ ОТНОСИТЕЛЬНО КОНФИДЕНЦИАЛЬНОСТИ
	p
		| Если у вас возникнут вопросы в отношении Политики Конфиденциальности Компании
		| или обработки данных Компанией, Вы можете связаться с нами по контактам для
		| обратной связи.

	h2 VII. Обращения пользователей
	p
		| К настоящей Политике конфиденциальности и отношениям между Пользователем
		| и Оператором применяется действующее законодательство РФ.
	p
		| Пользователи вправе направлять Оператору свои запросы, в том числе запросы
		| относительно использования их персональных данных, направления отзыва согласия
		| на обработку персональных данных в письменной форме по адресу, указанному разделе
		| Общие положения настоящего положения, или в форме электронного документа,
		| подписанного квалифицированной электронной подписью в соответствии
		| с законодательством РФ, и отправленного по средствам формы обратной связи.
		| Запрос, направляемый Пользователем, должен соответствовать требованиям,
		| установленным Правилами подачи обращений в Службу сервиса и поддержки, а именно
		| содержать:

	ul
		li
			| номер основного документа, удостоверяющего личность пользователя или его
			| представителя;
		li
			| сведения о дате выдачи указанного документа и выдавшем его органе;
		li
			| сведения, подтверждающие участие пользователя в отношениях с Оператором
			| (в частности, порядковый номер id пользователя или короткое (поддоменное) имя,
			| заменяющее порядковый номер id);
		li
			| подпись Пользователя или его представителя;
		li
			| адрес электронной почты;
		li
			| контактный телефон.

	p
		| Оператор обязуется рассмотреть и направить ответ на поступивший запрос Пользователя
		| в течение 30 дней с момента поступления обращения.

	h3 ДРУГОЕ
	p
		| Во всем остальном, что не отражено напрямую в Политике Конфиденциальности,
		| Компания обязуется руководствоваться нормами и положениями Федерального закона
		| от 27.07.2006 N 152-ФЗ «О персональных данных»
	p
		| Посетитель сайта Компании, предоставляющий свои персональные данные
		| и информацию, тем самым соглашается с положениями данной Политики
		| Конфиденциальности.
	p
		| Компания оставляет за собой право вносить любые изменения в Политику в любое время
		| по своему усмотрению с целью дальнейшего совершенствования системы защиты
		| от несанкционированного доступа к сообщаемым Пользователями персональным данным
		| без согласия Пользователя. Когда мы вносим существенные изменения в Политику
		| Конфиденциальности, на нашем сайте размещается соответствующее уведомление вместе
		| с обновлённой версией Политики Конфиденциальности.
	p
		| Действие настоящей Политики не распространяется на действия и интернет-ресурсов
		| третьих лиц.
</template>

<script>
import PageText from 'elysium-common/components/page/text';

export default {
	asyncRouteData({ store }) {
		store.commit('setCrumbs', [{
			text: 'Политика конфиденциальности'
		}]);
	},
	components: {
		PageText
	}
}
</script>


// WEBPACK FOOTER //
// Policy.vue?d5b3ae5e